import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ClaimsSubRouteLayout } from '../components/ClaimsSubRouteLayout'
import { useDispatch, useSelector } from 'react-redux'
import { getClaimDeductiblesList, getClaimsDeductibles, getStatus, Status } from 'redux/reducers/claims'
import { ClaimDeductibleCard } from 'containers/Claims/components/ClaimDeductibleCard'
import { MySpinner } from 'components/MySpinner/MySpinner'
import { Alert } from '@cmsgov/ds-medicare-gov'

export const ClaimDeductibles: FC = () => {
  const { t } = useTranslation('claimsSearch', { keyPrefix: 'claimDeductibles' })
  const dispatch = useDispatch()
  const deductibles = useSelector(getClaimDeductiblesList)
  const status = useSelector(getStatus)
  const isLoading = status === Status.LOADING
  const isError = status === Status.ERROR

  useEffect(() => {
    dispatch(getClaimsDeductibles())
  }, [dispatch])

  return (
    <>
      <ClaimsSubRouteLayout pageHeading={t('claimDeductiblesHeading')}>
        <div className='ds-l-container my-c-claim-deductibles ds-u-margin-bottom--2'>
          <div className='ds-l-row'>
            <div className='ds-l-col--12'>
              {(isLoading && !isError) && (
                <MySpinner />
              )}
              {(!isLoading && !isError && deductibles.deductibleList) && (
                <>
                  {deductibles.deductibleList.slice(0, deductibles.deductibleList.length).map((deductible, index) => (
                    <div className='m-c-card ds-u-padding--2 ds-u-margin-top--2' key={index}>
                      <ClaimDeductibleCard deductible={deductible}></ClaimDeductibleCard>
                    </div>
                  ))}
                </>
              )}
              {isError && (
                <Alert variation='warn' role='alert' hideIcon={true}>
                  <p className="ds-c-alert__text">{t('errorMessage')}</p>
                </Alert>
              )}
            </div>
          </div>
        </div>
      </ClaimsSubRouteLayout>
    </>
  )
}
